<template>
  <div class="hot-tools">
    <div class="tools-list-header">
      <!--<p class="title-row">
        <span class="title-sub">HOT</span>
        <span class="list-title">热门</span>
      </p>-->
      <p class="description">
        <span>工具库维护已迁移至《客户服务云平台》请</span><a style="font-size:24px;" href="https://support.seeyon.com/cbo_catalogue.html"> 前往 </a><span>下载使用</span>
      </p>
    </div>
    <!--
    <a-empty v-if="list.length == 0" description="暂无热门工具" />
    <div class="slider-wrapper" v-else>
      <a-icon
        v-if="list.length"
        type="left-circle"
        :class="['click-btn', 'left-click', { disable: curIndex == 0 }]"
        @click="prev"
      />
      <a-icon
        v-if="list.length"
        type="right-circle"
        :class="[
          'click-btn',
          'right-click',
          { disable: curIndex == list.length - 1 },
        ]"
        @click="next"
      />
      <div :class="['slider', {'center': list.length < 5}]">
      -->
        <!-- 只展示 10 个热门工具 -->
        <!--
        <div class="slider-content" :style="{ marginLeft: slideWidth + 'px' }">
          <ItemCard
            v-for="(item, index) in list.slice(0, 10)"
            :key="index"
            :isActive="index == curIndex"
            :curToolObj="item"
            @toDetail="$emit('toDetail', item.id)"
            @verify="(url) => { $emit('verify', url) }"
          ></ItemCard>
        </div>
      </div>
      <a-space class="slider-dots">
        <span
          :class="['dot', { active: index == curIndex }]"
          v-for="(item, index) in list"
          :key="'dot_' + index"
          @click="changeIndex(index)"
        ></span>
      </a-space>
    </div>
    -->
  </div>
</template>
<script>
//import ItemCard from "../cmps/ItemCard.vue";
export default {
  name: "hot-tools",
  props: {
    list: {
      type: Array,
    },
  },
  components: {
    //ItemCard,
  },
  created() {
    
  },
  data() {
    return {
      curIndex: 0,
      slideWidth: 0,
      loadding: true
    };
  },
  methods: {
    prev() {
      if (this.curIndex == 0) {
        return;
      }
      this.slideWidth = parseInt(this.slideWidth + 328);
      this.curIndex -= 1;
    },
    next() {
      if (this.curIndex == this.list.length - 1) {
        return;
      }
      this.slideWidth = parseInt(this.slideWidth - 328);
      this.curIndex += 1;
    },
    changeIndex(index) {
      var space = this.curIndex - index;
      if (space > 0) {
        this.slideWidth = parseInt(this.slideWidth + 328 * Math.abs(space));
      } else if (space < 0) {
        this.slideWidth = parseInt(this.slideWidth - 328 * Math.abs(space));
      }
      this.curIndex = index;
    },
  },
  computed: {},
  watch: {},
};
</script>
<style scoped>
.hot-tools {
  width: 100%;
  /* min-height: 480px; */
  padding: 80px 0 50px;
  background: #ffffff;
}
.slider-wrapper {
  width: 100%;
  padding: 0 60px;
  margin: 0 auto;
  position: relative;
}
.slider {
  width: calc(100% - 140px);
  padding: 40px 0 60px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  overflow-x: hidden;
}
.slider.center {
  justify-content: center;
}
.slider-content {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  transition: all 0.4s;
  -moz-transition: all 0.4s; /* Firefox 4 */
  -webkit-transition: all 0.4s; /* Safari 和 Chrome */
  -o-transition: all 0.4s; /* Opera */
}
.click-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 45px;
  color: #007AFF;
  opacity: 0.6;
  cursor: pointer;
  transition: all 0.3s;
  -moz-transition: all 0.3s; /* Firefox 4 */
  -webkit-transition: all 0.3s; /* Safari 和 Chrome */
  -o-transition: all 0.3s; /* Opera */
}
.left-click {
  left: 40px;
}
.right-click {
  right: 40px;
}
.click-btn.disable {
  opacity: 0.2;
  cursor: not-allowed;
}
.click-btn.disable:hover {
  opacity: 0.2;
}
.click-btn:hover {
  opacity: 0.8;
}
.slider-dots {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #d8d8d8;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  -moz-transition: all 0.3s; /* Firefox 4 */
  -webkit-transition: all 0.3s; /* Safari 和 Chrome */
  -o-transition: all 0.3s; /* Opera */
}
.dot.active {
  background: #007AFF;
}
</style>